import { cn } from '@/lib/utils'
import type { ComplianceSlot } from '@/models/vault'
import { SLOT_COLUMNS } from './slotColumns'
import { SlotRow, type SlotRowActions } from './SlotRow'

/** Aligned to the boxes below it, but not one itself — and gone where the rows stack into cards. */
function Header() {
  return (
    <div className="text-muted-foreground hidden w-full items-center gap-3 px-4 text-sm font-medium lg:flex">
      <span className={SLOT_COLUMNS.document}>Document</span>
      <span className={SLOT_COLUMNS.status}>Status</span>
      <span className={SLOT_COLUMNS.expires}>Expires</span>
      <span className={cn(SLOT_COLUMNS.actions)} />
    </div>
  )
}

export function SlotTable({ slots, ...actions }: { slots: ComplianceSlot[] } & SlotRowActions) {
  return (
    <div className="flex flex-col gap-2">
      <Header />
      {slots.map((slot, index) => (
        // The optional slots close the list; a double gap marks where they start.
        <div
          key={slot.key}
          data-slot="slot"
          className={cn(!slot.required && index > 0 && slots[index - 1].required && 'mt-2')}
        >
          <SlotRow slot={slot} {...actions} />
        </div>
      ))}
    </div>
  )
}
